module.exports = __webpack_public_path__ + "img/change.85c1401e.svg";